<template>
<div class="credential-bg">
    <div  class="overlay-shade">

    </div>
    <div class="row">
      <div class="left-side col-md-7"></div>
      <div class="right-side col-md-4">
        <div>
          <div class="app flex-row align-items-center">
              <b-col offset-md="1" md="10" sm="12">
                <b-card no-body>
                    <b-card-body class="p-4">
                      <b-form @submit.prevent="Login">
                      <div style="width:100%;" class="text-center logo">
                          <img height="110px;" src="../../../public/img/paorosheba-logo-chandpur.png" alt="">
                      </div>
                      <div style="width:100%" class="text-center heading">
                        <h1>লগইন ফর্ম</h1>
                      </div>
                      <div v-if="loginNotification.error" class="help-block alert alert-danger">
                        <p>{{loginNotification.error}}</p>  
                      </div>
                      <b-input-group class="mb-3">
                        <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                        <b-form-input v-validate="'required'" data-vv-as="email" name="email_field"  v-model="login.email" type="text" class="form-control" placeholder="ইমেইল/ মোবাইল নম্বর" autocomplete="email" />
                      </b-input-group>
                      <p style="color:red !important" v-if="errors.has('email_field')" class="text-muted">* {{ errors.first('email_field') }}</p>
                      <b-input-group class="mb-4">
                        <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                        <b-form-input name="password" v-validate="'required|min:6|max:15'" v-model="login.password" type="password" class="form-control" placeholder="পাসওয়ার্ড" autocomplete="current-password" />
                      </b-input-group>
                      <p style="color:red !important" v-if="errors.has('password')" class="text-muted">* {{ errors.first('password') }}</p>
                      <b-row>
                        <b-col cols="12" class="text-center">
                          <b-button v-if="! loader" type="submit" variant="success" block class="px-4"><i v-if="check" class="fa fa-check"></i> লগইন </b-button>
                          <b-button v-if="loader" type="submit" variant="success" block class="px-4"  disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>লগইন...
                        </b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                      <b-row>
                            <b-col cols="12" class="text-center bottom-text">
                              <p style="margin:0px;">ইতিমধ্যে আপনার নিবন্ধন না থাকলে <span @click="go()" style="text-decoration: underline;cursor:pointer;border-bottom:underline;font-family:Hind Siliguri Light">নিবন্ধন করুন</span></p>
                              <p style="margin:0px;">পাসওয়ার্ড ভুলে গেলে <span style="text-decoration: underline;cursor:pointer;border-bottom:underline;font-family:Hind Siliguri Light">পুনরুদ্ধার করুন</span></p>
                              
                            </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
            </div>
            <div class="footer">
                <span>কারিগরি সহযোগিতায় </span>&nbsp;<img @click="goOrange()" style="cursor:pointer;" height="20px;" src="../../../public/img/orangebd.png" alt="">
            </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import {LOGIN_USER} from "../../store/action.type"
import { mapState,mapGetters } from "vuex"
export default {
  name: 'Login',
  data(){
    return{
      loader:false,
      check:false,
      login:{
        email:'',
        password:''
      }
    }
  },
  methods:{
    Login(){
      this.$validator.validateAll().then( result =>{
          if(result){
            var data = this.login
            this.loader=true
            this.$store.dispatch('LOGIN_USER',data)
            .then(response=>{ 
                this.loader=false
                this.check=true
            })
            .catch(error=>{
                this.loader=false
                this.check=false      
            });
          }  
      })
    },
    go(){
      this.$router.push('/register');
    },
    goOrange(){
      window.open('http://www.orangebd.com/')
    }
  },
  computed:{
    ...mapGetters(["loginNotification"])
  }
}
</script>
<style scoped>
  .credential-bg{
      position: fixed;
      content: "";
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background: url('./img/bg3.jpg');
      background-size: cover;
  }
  .left-side{
    /* width: 60%; */
  }
  .right-side{
    background-image: linear-gradient(to bottom, #ffffff80, #00000080);
    position: relative;
  }
  .overlay-shade{
    position: absolute;
    width: 100%;
    height: 50%;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to top, black, transparent);
  }
  .card{
    background-color: transparent;
    border: 0px solid #fff;
  }
  .logo{
    margin-bottom: 1.5rem;
  }
  .heading{
    padding-top: 2rem;
    padding-bottom: 1rem;
  }
  .heading h1{
    font-family: "Hind Siliguri Light";
    color: #5a8f32;
    font-weight: 700;
    background: rgb(209, 247, 234);
    padding: 2px;
    border-radius: 20px;
  }
  input{
    font-family: "SolaimanLipi";
  }
  p{
    font-family: "SolaimanLipi";
  }
  button{
    font-family: "Hind Siliguri Light";
  }
  ::placeholder{
    font-family: "SolaimanLipi";
  }
  .btn-link{
    color:#cbf0ae;
    font-size:16px;
  }
  .btn-link:hover{
    color:#95f74a;
  }
  .bottom-text{
    margin-top: 15px;
    color:#cbf0ae;
    font-size:16px;
  }
  .bottom-text span:hover{
    color:#95f74a;
  }
  .footer{
    width: 100%;
    text-align: center;
    /* background: rgb(255, 255, 255,0.3); */
    position: absolute;
    bottom: 0;
    left: 0;
    padding-top: 40px;
    padding-bottom: 10px;
    /* color: #fff; */
    font-family: "SolaimanLipi";
    background-image: linear-gradient(to top, #fff, transparent);
    font-size: 20px;
  }
  @media only screen and (max-width: 600px) {
    .credential-bg{
      overflow: auto;
      overflow-x: hidden;
    }
  }
</style>
